import BotaoContato from "../../componentes/BotaoContato/BotaoContato.js";
import BotaoContatoOutline from "../../componentes/BotaoContatoOutline/BotaoContatoOutline.js";
import "./Header.css";
import { useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';

function Header() {

  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  return (
    <header className="header-banner scroll-reveal-opacity">

      {/* IMAGEM DE FUNDO */}
      <img
        src={require("../../assets/img/imgFloresta1.png")}
        alt="Imagem de fundo"
        className="video-bg"
      />

      {/* OVERLAY + CONTEÚDO */}
      <div className="overlay-card scroll-reveal-zoom">
        <article className="conteudo">
          <h2 className="titulo-pequeno scroll-reveal-right">
            ENGENHARIA E MEIO AMBIENTE
          </h2>

          <h1 className="titulo-grande scroll-reveal-zoom">
            Serviços que conectam <span className="bgc-orange">inovação</span>,
            engenharia e meio ambiente.
          </h1>

          <p className="descricao">
            Pioneirando futuros sustentáveis por meio da excelência técnica e da
            integridade ecológica.
          </p>

          <nav className="botoes d-flex flex-wrap mb-5 mb-md-0 mb-lg-0 scroll-reveal-right">
            <a onClick={() => goToSection("servicos")} className="btn botao-contato m-md-0">
              Nossos Serviços
            </a>

            <BotaoContatoOutline
              texto="Contate"
              rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre os serviços da Âmbar"
            />
          </nav>
        </article>
      </div>
    </header>
  );
}

export default Header;
